import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LoadingBar, StatTable } from 'components/Commons';

import cm from 'helpers/commons';

class DivisionStatsResult extends Component {
  recursionToList = (recursionList, statDivision) => {
    if (statDivision.division) {
      for (let i = 0, length = statDivision.division.length; i < length; i++) {
        recursionList.push(statDivision.division[i]);
        recursionList = this.recursionToList(recursionList, statDivision.division[i]);
      }
    }
    return recursionList;
  };

  // 전체 금액 계산 함수 (최상위 부서만 합산하여 중복 방지)
  calculateTotalAmounts = (divStats) => {
    if (!divStats || !divStats.data || !divStats.data.stat) {
      return {
        totalSalesPrice: 0,
        totalCompanyPrice: 0,
        totalMcount: 0,
        totalCancelPrice: 0
      };
    }

    let totalSalesPrice = 0;
    let totalCompanyPrice = 0;
    let totalMcount = 0;
    let totalCancelPrice = 0;

    divStats.data.stat.forEach((item) => {
      const { division } = item;
      let list = [];

      division.forEach((val1) => {
        list.push(val1);
        list = this.recursionToList(list, val1);
      });

      if (list && list.length > 0) {
        // depth=1인 최상위 부서만 합산 (하위 부서는 이미 상위 부서에 포함됨)
        list.forEach((val1) => {
          if (val1.depth === 1) {
            totalSalesPrice += val1.totalsalesprice || 0;
            totalCompanyPrice += val1.totalcompanyprice || 0;
            totalMcount += val1.totalmcount || 0;
            totalCancelPrice += val1.totalcancelprice || 0;
          }
        });
      }
    });

    return {
      totalSalesPrice,
      totalCompanyPrice,
      totalMcount,
      totalCancelPrice
    };
  };

  render() {
    /* 도원님 짱~! */
    const { divStats } = this.props;
    let divisionDepth = 1;

    let tabledata;
    if (divStats) {
      divisionDepth = divStats && divStats.data ? divStats.data.depth : 1;

      if (divStats.data) {
        const { stat } = divStats.data;
        tabledata =
          stat && stat.length > 0
            ? stat.map((item) => {
                const { division } = item;
                let list = [];

                division.forEach((val1) => {
                  list.push(val1);
                  list = this.recursionToList(list, val1);
                });

                let arr = [];
                if (list && list.length > 0) {
                  list.forEach((val1) => {
                    let rows = {
                      // backgroundColor:"#e6f7ee",
                      row: []
                    };

                    let row = [];
                    row.push({ content: item.sdate, textAlign: 'left' });

                    let maxDepth = divisionDepth;
                    let depth = val1.depth;

                    for (let i = 1, length = maxDepth; i <= length; i++) {
                      if (val1.depth === 1) {
                        rows['backgroundColor'] = '#e6f7ee';
                      } else if (val1.depth === 2) {
                        rows['backgroundColor'] = '#F3FBF6';
                      }

                      if (i === depth) {
                        row.push({ content: val1.name, textAlign: 'left', isTooltip: true, maxWidth: 150 });
                      } else {
                        row.push({ content: '-', fontColor: '#e6f7ee', maxWidth: 150 });
                      }
                    }
                    row.push({ content: cm.numberComma(val1.totalsalesprice), textAlign: 'right' });
                    row.push({ content: cm.numberComma(val1.totalcompanyprice), textAlign: 'right' });
                    row.push({ content: cm.numberComma(val1.totalmcount), textAlign: 'right' });
                    row.push({
                      content: val1.totalcancelprice ? cm.convertMinusNumber(val1.totalcancelprice) : '-',
                      fontColor: '#e20b44',
                      textAlign: 'right'
                    });

                    rows['row'] = row;

                    arr.push(rows);
                  });
                }
                let obj = {
                  header: [{ content: item.sdate, colSpan: divisionDepth + 5 }],
                  body: arr
                };

                return obj;
              })
            : '부서 통계 내역이 없습니다.';
      } else if (divStats.response) {
        tabledata = divStats.response.data.message;
      }
    } else {
      tabledata = '부서 통계 내역이 없습니다.';
    }

    let loading = '';
    if (!tabledata) {
      loading = <LoadingBar />;
    }

    let header = [
      { content: '날짜', textAlign: 'left' },
      { content: '회사식대', textAlign: 'right' },
      { content: '정산금액', textAlign: 'right' },
      { content: '식사횟수', textAlign: 'right' },
      { content: '취소금액', textAlign: 'right' }
    ];

    header = cm.tableHeaderList(header, 1, false, 'stat', divisionDepth);
    let colWidth = cm.colWidth([121, 98, 140, 121, 98, 80, 98], 1);

    // 전체 금액 계산
    const totalAmounts = this.calculateTotalAmounts(divStats);

    return (
      <div className="division-stat-result table-container">
        {loading}

        <div className="table-box">
          <StatTable colWidth={colWidth} header={header} data={tabledata} />
        </div>

        {/* 전체 합계 표시 */}
        {divStats && divStats.data && divStats.data.stat && (
          <div
            className="total-summary"
            style={{
              marginTop: '20px',
              padding: '15px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '4px'
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              <span style={{ color: '#495057' }}>전체 합계</span>
              <div style={{ display: 'flex', gap: '20px' }}>
                <span>회사식대: {cm.numberComma(totalAmounts.totalSalesPrice)}원</span>
                <span>정산금액: {cm.numberComma(totalAmounts.totalCompanyPrice)}원</span>
                <span>식사횟수: {cm.numberComma(totalAmounts.totalMcount)}회</span>
                <span style={{ color: '#e20b44' }}>
                  취소금액: {totalAmounts.totalCancelPrice ? cm.convertMinusNumber(totalAmounts.totalCancelPrice) : '-'}원
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

DivisionStatsResult = connect((state) => ({
  divStats: state.usage.divisionStats
}))(DivisionStatsResult);

export default DivisionStatsResult;
